var utils = require("../utils");

var CustomDateField = function (config) {
  jsGrid.Field.call(this, config);
};

CustomDateField.prototype = new jsGrid.Field({
  css: "date-dclg", // redefine general property 'css'

  itemTemplate: function (value) {
    if(!value)
    {
      return "n/a";
    }
    else
    {
      return utils.cleanDate(value);
    }
  },
});

module.exports = CustomDateField;
